import SectionCard from '../shared/SectionCard'
import { Stack } from './styled-components'
import CacheForm from '@/containers/DevToolsNew/Cache/CacheForm'

const CachePage = () => {
  return (
    <Stack>
      <SectionCard>
        <CacheForm />
      </SectionCard>
    </Stack>
  )
}

export default CachePage
